import {createContext} from "react"

const AdminTransfersContext = createContext(null);

export default  AdminTransfersContext;